import type { PrivateEventDetail } from '../../api/privateEvents';
import { useViewport } from '../../hooks/useViewport';

import Fact from './Fact';
import PersonValue from './PersonValue';
/** Who is on the hook for the event, with "Not recorded" for what an import
 *  never held. */
export default function PeopleRow({ event }: { event: PrivateEventDetail }) {
  const { isPhone } = useViewport();
  const { migrated } = event;
  return (
    <div
      style={{
        gridColumn: '1 / -1',
        display: 'grid',
        gridTemplateColumns: isPhone ? '1fr' : 'repeat(3, 1fr)',
        gap: 14,
        paddingTop: 12,
        borderTop: '1px solid var(--nb-border)',
      }}
    >
      <Fact label="National coordinator">
        <PersonValue
          person={event.nationalCoordinator}
          field="National coordinator"
          migrated={migrated}
        />
      </Fact>
      <Fact label="Regional coordinator (owner)">
        <PersonValue person={event.owner} field="Regional coordinator" migrated={migrated} />
      </Fact>
      <Fact label="Deal originator">
        <PersonValue person={event.dealOriginator} field="Deal originator" migrated={migrated} />
      </Fact>
    </div>
  );
}
